import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TruthSection() {
  return <section className="w-full bg-white py-20 px-6 md:px-8" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-183">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B2141] mb-10" data-id="element-184">
            La verdad incómoda{' '}
            <span className="italic text-[#C9A96E]" data-id="element-185">(pero liberadora)</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center text-left" data-id="element-186">
            <div className="space-y-6 text-lg text-[#2D2D2D] leading-relaxed" data-id="element-187">
              <p data-id="element-188">
                No es que te falte disciplina. No es que “no lo estés haciendo
                bien”.
              </p>
              <p data-id="element-189">
                Es que casi todos los consejos son para{' '}
                <span className="font-semibold" data-id="element-190">antes</span> de dormir… y tú
                necesitas ayuda{' '}
                <span className="font-semibold" data-id="element-191">
                  cuando ya estás despierta.
                </span>
              </p>
              <p data-id="element-192">
                <span className="font-semibold text-[#1B2141]" data-id="element-193">
                  Higiene del sueño
                </span>{' '}
                suena bien, pero a las 3:00 AM no quieres un artículo.
              </p>
            </div>

            <div className="relative bg-[#FAF6F0] p-8 rounded-xl border border-[#E8E0D4]" data-id="element-194">
              <Quote className="absolute top-4 left-4 w-8 h-8 text-[#C9A96E]/30 rotate-180" data-id="element-195" />
              <p className="font-serif text-2xl text-[#1B2141] leading-snug text-center pt-4" data-id="element-196">
                “A las 3:00 AM no quieres un artículo. Quieres instrucciones
                claras.”
              </p>
              <Quote className="absolute bottom-4 right-4 w-8 h-8 text-[#C9A96E]/30" data-id="element-197" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}